import script from "./RecentPages.vue?vue&type=script&setup=true&lang=js"
export * from "./RecentPages.vue?vue&type=script&setup=true&lang=js"

import "./RecentPages.vue?vue&type=style&index=0&id=9b1ce70c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b1ce70c"]])

export default __exports__